// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import groupClosePointers from './utils/group/groupClosePointers';

/**
 * This component will group and merge pointers that are close together.
 */
export default (DecoratedComponent) => {
    class GroupPointersDecorator extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                groupedPointers: [],
            };
        }

        componentWillMount() {
            this.groupNearbyPointers(this.props);
        }

        componentWillReceiveProps(nextProps) {
            this.groupNearbyPointers(nextProps);
        }

        groupNearbyPointers = (props) => {
            const { pointers, layerRect } = props;

            const groupedPointers = groupClosePointers({ pointers, layerRect });

            this.setState({ groupedPointers });
        };

        render() {
            const { groupedPointers } = this.state;

            return <DecoratedComponent {...this.props} pointers={groupedPointers} />;
        }
    }

    GroupPointersDecorator.propTypes = {
        pointers: PropTypes.array.isRequired,
        layerRect: PropTypes.object.isRequired,
    };

    return GroupPointersDecorator;
};
